<template>
  <div class="cart-summary critical-component-clear">
    <div class="cart-summary__total">
      <p
        class="text-body-m-regular"
        :class="{ 'text-body-l-regular-desktop': !small }"
      >
        {{ $string('cart.summary.total_label') }}

        <span
          class="cart-summary__item-count"
          v-text="$string(
            'cart.item_count',
            {
              replace: { count: cart.item_count },
              pluralise: cart.item_count,
            }
          )"
        />
      </p>

      <p
        class="text-body-m-regular"
        :class="{ 'text-body-l-regular-desktop': !small }"
        v-text="$formatMoney(cart.total_price)"
      />
    </div>

    <p
      class="text-body-s-regular cart-summary__shipping"
      v-text="$string('cart.summary.shipping')"
    />

    <cart-gift-note
      v-if="$variable('request.pageType') === 'cart'"
    />

    <!-- computedMessage ab test add to cart notice -->
    <btn
      class="cart-summary__submit"
      :label="computedMessage"
      name="checkout"
      type="button"
      :url="`${$variable('routes.normalisedRoot')}checkout`"
    />

    <slot name="express-checkout" />

    <p
      v-if="selectedCountry === 'US' && $variable('request.pageType') === 'cart'"
      class="main-product__affirm affirm-as-low-as"
      data-page-type="cart"
      :data-amount="cart.total_price"
    />
    <div class="value-prop--wrapper">
      <div class="value-prop--item">
        <img
          src="https://cdn.shopify.com/s/files/1/0727/3745/6428/files/delivery-status_1.png?v=1725483783"
          width="32"
          height="32"
          role="presentation"
        >
        <p
          v-html="selectedCountry === 'US' ?
            $string('cart.summary.shipping_value_us_html') :
            $string('cart.summary.shipping_value_international')"
        />
      </div>

      <div class="value-prop--item">
        <img
          src="https://cdn.shopify.com/s/files/1/0727/3745/6428/files/recycle.png?v=1722961319"
          width="32"
          height="32"
          role="presentation"
        >
        <p v-html="$string('cart.summary.source_value_html')" />
      </div>

      <div class="value-prop--item">
        <img
          src="https://cdn.shopify.com/s/files/1/0727/3745/6428/files/plier.png?v=1722961337"
          width="32"
          height="32"
          role="presentation"
        >
        <p v-html="$string('cart.summary.white_glove_value_html')" />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Cart summary (cart-summary)
 * -----------------------------------------------------------------------------
 * Summary of cart metrics with checkout CTA.
 *
 * @param {Boolean} [small] - Use mobile layout at all breakpoints.
 *
 */
import { mapState } from 'vuex'

import Btn from '~global/btn/btn'
import CartGiftNote from '~async/cart-gift-note/cart-gift-note'

export default {
  name: 'CartSummary',

  components: {
    Btn,
    CartGiftNote,
  },

  props: {
    // ab test add to cart notice
    message: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedCountry: window.cnvs.store.country,
    }
  },

  computed: {
    // ab test add to cart notice
    computedMessage() {
      return this.message || this.$string('cart.checkout')
    },

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
    }),
  },
  watch: {

    /**
     * Refresh affirm when cart total price changes
     */
    'cart.total_price'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick().then(() => {
          this.refreshAffirm()
        })
      }
    },
  },

  mounted() {
    this.refreshAffirm()
  },

  methods: {

    /**
     * Refresh affirm
     */
    refreshAffirm() {
      const { affirm } = window
      if (this.selectedCountry !== 'US' || !affirm?.ui) {
        return
      }

      affirm.ui.ready(() => {
        affirm.ui.refresh()
      })
    },
  },
}
</script>

<style lang="scss">
@import './cart-summary';
</style>
